import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/profile/user-4.jpg")